import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt, faLanguage, faToolbox, faHeart, faBriefcase, faGraduationCap, faLink } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin, faYoutube, faUpwork, faTelegram, faFacebook, faTwitter, faInstagram, faMedium, faBehance, faDribbble, faStackOverflow, faAngellist, faQuora, faVimeo, faSoundcloud } from '@fortawesome/free-brands-svg-icons';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import '../styles/TemplateFour.css';

const TemplateFour = ({ template, onClick }) => {
    const linkIcons = {
        github: faGithub,
        linkedin: faLinkedin,
        youtube: faYoutube,
        upwork: faUpwork,
        telegram: faTelegram,
        facebook: faFacebook,
        website: faLink,
        portfolio: faLink, // Assume generic link icon
        twitter: faTwitter,
        instagram: faInstagram,
        medium: faMedium,
        behance: faBehance,
        dribbble: faDribbble,
        stackoverflow: faStackOverflow,
        angellist: faAngellist,
        quora: faQuora,
        vimeo: faVimeo,
        soundcloud: faSoundcloud
    };

    const linkText = {
        github: 'GitHub',
        linkedin: 'LinkedIn',
        youtube: 'YouTube',
        upwork: 'Upwork',
        telegram: 'Telegram',
        facebook: 'Facebook',
        website: 'Website',
        portfolio: 'Portfolio',
        twitter: 'Twitter',
        instagram: 'Instagram',
        medium: 'Medium',
        behance: 'Behance',
        dribbble: 'Dribbble',
        stackoverflow: 'Stack Overflow',
        angellist: 'AngelList',
        quora: 'Quora',
        vimeo: 'Vimeo',
        soundcloud: 'SoundCloud'
    };

    // Generate random skill levels for visualization
    const skillsWithLevels = template?.skills.map(skill => ({
        name: skill,
        level: Math.floor(Math.random() * 51) + 50 // Random level between 50 and 100
    }));

    const softwareSkillsWithLevels = template?.softwareSkills.map(skill => ({
        name: skill,
        level: Math.floor(Math.random() * 51) + 50 // Random level between 50 and 100
    }));


    return (
        <div className="template-four-container" onClick={() => onClick(template?.id)}>

            <div className="template-four-header">
                <div className="header-details">

                    {template?.name && <h1 className="template-four-name" style={{ color: 'white' }}>{template?.name}</h1>}
                </div>
                {template?.image && <img src={template?.image} alt={template?.personName} className="template-four-image" />}

            </div>

            <div className="template-four-details">

                {template?.contact && (
                    <div className="template-four-section">
                        <strong>Contact</strong>
                        <div className="template-four-contact-info">
                            {template.contact.email && <p><FontAwesomeIcon icon={faEnvelope} /> {template.contact.email}</p>}
                            {template.contact.phone && <p><FontAwesomeIcon icon={faPhone} /> {template.contact.phone}</p>}
                            {template.contact.address && <p><FontAwesomeIcon icon={faMapMarkerAlt} /> {template.contact.address}</p>}
                        </div>
                    </div>
                )}
                {template?.aboutMe && template?.aboutMe.length > 0 && (
                    <div className="template-four-section">
                        <strong>About Me:</strong>
                        <p>{template?.aboutMe}</p>
                    </div>
                )}
                {template?.skills && template?.skills.length > 0 && (
                    <div className="template-four-section">
                        <strong>Skills:</strong>
                        <div className="template-four-skills-wrapper">
                            {skillsWithLevels.map((skill, index) => (
                                <div key={index} className="template-four-skill-item">
                                    <span className="template-four-skill-name">{skill.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {template?.softwareSkills && template?.softwareSkills.length > 0 && (
                    <div className="template-four-section">
                        <strong>Software Skills:</strong>
                        <div className="template-four-skills-wrapper">
                            {softwareSkillsWithLevels.map((skill, index) => (
                                <div key={index} className="template-four-skill-item">
                                    <span className="template-four-skill-name">{skill.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {template?.workExperience && template?.workExperience.length > 0 && (
                    <div className="template-four-section">
                        <strong>Work Experience:</strong>
                        {template?.workExperience.map((experience, index) => (
                            <div key={index} className="template-four-work-experience-item">
                                {experience.role && <p className="template-four-role">{experience.role} at {experience.company}</p>}
                                {experience.location && (
                                    <p className="location">
                                        (
                                        {experience.startDate && new Date(experience.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                        {experience.endDate !== "Present" ? new Date(experience.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                        )
                                    </p>
                                )}
                                {experience.description && <p className="template-four-description">{experience.description}</p>}
                            </div>
                        ))}
                    </div>
                )}
                {template?.education && Array.isArray(template?.education) && template?.education.length > 0 && (
                    <div className="template-four-section">
                        <strong>Education:</strong>
                        {template?.education.map((edu, index) => (
                            <div key={index} className="template-four-education-item">
                                {edu.degree && <p className="template-four-degree">{edu.degree} from {edu.institution}</p>}
                                <p>
                                    (
                                    {edu.startDate && new Date(edu.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                    {edu.endDate !== "Present" ? new Date(edu.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                    )
                                </p>

                                {edu.description && <p className="template-four-description">{edu.description}</p>}

                            </div>
                        ))}
                    </div>
                )}

                {template?.certificates && template?.certificates.length > 0 && (
                    <div className="template-four-section">
                        <strong><FontAwesomeIcon icon={faGraduationCap} /> Certificates:</strong>
                        {template?.certificates?.map((certificate, index) => (
                            <div key={index} className="template-four-education-item">
                                <p className="template-four-degree">Title: {certificate.title}</p>
                                <p className="template-four-institution">Institution: {certificate.institution}</p>
                                <p className="template-four-date">
                                    Date Received: {new Date(certificate.DateReceived).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                                </p>
                            </div>
                        ))}
                    </div>
                )}

                {template?.languages && template?.languages.length > 0 && (
                    <div className="template-four-section">
                        <strong>Languages:</strong>
                        <p>{template?.languages.join(', ')}</p>
                    </div>
                )}
                {template?.hobbies && template?.hobbies.length > 0 && (
                    <div className="template-four-section">
                        <strong>Hobbies:</strong>
                        <p>{template?.hobbies.join(', ')}</p>
                    </div>
                )}

                {template?.links && template?.links.length > 0 && (
                    <div className="template-four-section">
                        <div className="template-four-links">
                            <strong>Links:</strong>
                            {template.links.map(([key, value]) => (
                                <p key={key} className="template-four-link">
                                    <FontAwesomeIcon icon={linkIcons[key] || faLink} /> <a href={value} target="_blank" rel="noopener noreferrer"> <span className="template-four-link-text">{linkText[key]}</span></a>
                                </p>
                            ))}
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};

export default TemplateFour;
